<template>
  <Modal name="ADD_TO_GROUP_MODAL" width="420" :title="titleLabel">
    <template v-slot:body>
      <v-progress-linear v-if="isSearchGroup" height="5" indeterminate absolute rounded top />

      <p class="body-2">
        {{ messageLabel }}
      </p>
      <v-autocomplete
        :search-input.sync="groupSearch"
        :loading="isSearchGroup"
        :items="groups"
        prepend-inner-icon="mdi-magnify"
        item-text="code"
        item-value="id"
        label="Search Group"
        outlined
      >
        <template v-slot:item="{ props, item }">
          <div @click.prevent="addToSelected(item)" :style="{ width: '100%' }">
            Add to group <strong>{{ item && item.code ? item.code : '' }}</strong>
          </div>
        </template>
      </v-autocomplete>

      <small style="color: white; position: absolute; visibility: hidden;">
        {{ selectedGroup }}
      </small>

      <div v-if="selectedGroup">
        <v-divider class="mb-5" />
        <p class="text-center">
          {{ addThisAppointmentsToGroupLabel }}
          <strong>{{ selectedGroup.code }}</strong>?
        </p>
        <v-btn
          @click="addToGroup"
          :loading="isAddingToGroup"
          elevation="0"
          color="realEstate"
          block
          dark
        >
          {{ addLabel }}
        </v-btn>
      </div>
    </template>
  </Modal>
</template>

<script>
// store
import { mapActions, mapMutations } from 'vuex'

// api
import { getAppointments } from '@/services/dashboard/dashboardService'
import { listCustomerAppointmentGroup } from '@/services/appointment/appointmentService'

// components
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalAddAppointmentToGroup',

  components: {
    Modal,
  },

  props: {
    appointments: {
      type: Array,
      required: true,
    },

    selectedAppointments: {
      type: Array,
      required: false,
    }
  },

  watch: {
    groupSearch(term) {
      clearTimeout(this._timer)

      this._timer = setTimeout(() => {
        if (!term) return
        this.filters.search = term.toString()
        this.searchGroup()
      }, 1000)
    },
  },

  computed: {
    oldToken() {
      return localStorage.getItem('old_token')
    },

    isAdminOrPartner() {
      const roles = localStorage.getItem('access_roles')
      const userRoles = roles?.split(',')
      return userRoles?.includes('ROLE_ADMIN') || userRoles?.includes('ROLE_PARTNER')
    },
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['addAppointmentToGroup']),

    async adminFetchGroups() {
      const groups = await getAppointments(
        this.oldToken,
        undefined, // status
        undefined, // types
        undefined, // cities
        undefined, // hosts
        undefined, // client
        undefined, // startDate
        undefined, // endDate
        undefined, // startTime
        undefined, // endTime
        undefined, // page
        undefined, // findHostMode
        undefined, // country
        this.filters?.category,
        this.filters?.search?.toString(),
      )

      const response = await groups?.result

      return response
    },

    async customerFetchGroups() {
      const { data } = await listCustomerAppointmentGroup(this.filters)
      return data?.result
    },

    async searchGroup() {
      this.isSearchGroup = true

      try {
        let response = []

        if (this.isAdminOrPartner) {
          response = await this.adminFetchGroups()
        } else {
          response = await this.customerFetchGroups()
        }

        this.groups = (response || [])
          .filter(item => item && item.id && item.code)
          .map((item) => {
            return {
              id: item.id,
              code: item.code?.toString(),
            }
          })
      } catch (error) {
        console.log(`ERROR: ${error}`)
        this.groups = []
      } finally {
        this.isSearchGroup = false
      }
    },

    addToSelected(item) {
      this.selectedGroup = item
    },

    addToGroup() {
      this.isAddingToGroup = true

      let appointmentIds = []
      const groupId = this.selectedGroup.id

      if (this.selectedAppointments.length >= 1) {
        this.selectedAppointments.map((appointment) => appointmentIds.push(appointment.id))
      } else {
        appointmentIds = this.appointments.map((appointment) => appointment.id)
      }

      this.addAppointmentToGroup({ group_id: groupId, appointments: appointmentIds })
        .then(() => { this.$emit('refreshMap') })
        .then(() => this.closeAllModals())
        .finally(() => { this.isAddingToGroup = false })
    }
  },

  data() {
    return {
      _timer: null,
      isSearchGroup: false,
      isAddingToGroup: false,

      groups: [],
      groupSearch: null,
      selectedGroup: null,

      filters: {
        category: 'GROUP',
        search: '',
      },

      // labels
      titleLabel: this.$t('appointment.label.addToGroup.title'),
      messageLabel: this.$t('appointment.label.addToGroup.message'),
      addThisAppointmentsToGroupLabel: this.$t('appointment.label.addToGroup.addThisAppointmentsToGroup'),
      addLabel: this.$t('appointment.label.addToGroup.add'),
      cancelLabel: this.$t('appointment.label.addToGroup.cancel'),
    }
  },
}
</script>
